module.exports = __webpack_public_path__ + "img/grid-item-kynorelle-03.8455b5f2.webp";